import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import axios from '../utils/axios';
import axiosSWRFetcher from '../utils/swrFetcher';

export default function useGoals(companyId) {
  const { enqueueSnackbar } = useSnackbar();
  
  const { data, error, isValidating, mutate } = useSWR(
    companyId ? `/api/works/goal/crew/company/${companyId}/` : null,
    axiosSWRFetcher,
    {
      errorRetryInterval: 2000,
      revalidateOnFocus: false
    }
  );

  const createGoal = async (goalData) => {
    try {
      const response = await axios.post(`/api/works/goal/crew/company/${companyId}/`, goalData);
      enqueueSnackbar('요청사항이 등록되었습니다.', { variant: 'success' });
      mutate();
      return response.data;
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || '요청사항 등록에 실패했습니다.', { variant: 'error' });
      throw error;
    }
  };

  const updateGoal = async (goalId, goalData) => {
    try {
      const response = await axios.put(`/api/works/goal/crew/company/${companyId}/${goalId}/update/`, goalData);
      enqueueSnackbar('요청사항이 수정되었습니다.', { variant: 'success' });
      mutate();
      return response.data;
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || '요청사항 수정에 실패했습니다.', { variant: 'error' });
      throw error;
    }
  };

  const completeGoal = async (goalId) => {
    try {
      const response = await axios.post(`/api/works/goal/crew/company/${companyId}/${goalId}/complete/`);
      enqueueSnackbar('요청사항을 완료했습니다.', { variant: 'success' });
      mutate();
      return response.data;
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || '요청사항 완료 처리에 실패했습니다.', { variant: 'error' });
      throw error;
    }
  };

  const uncompleteGoal = async (goalId) => {
    try {
      const response = await axios.delete(`/api/works/goal/crew/company/${companyId}/${goalId}/complete/`);
      enqueueSnackbar('요청사항 완료를 취소했습니다.', { variant: 'info' });
      mutate();
      return response.data;
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || '요청사항 완료 취소에 실패했습니다.', { variant: 'error' });
      throw error;
    }
  };

  const deleteGoal = async (goalId) => {
    try {
      await axios.delete(`/api/works/goal/crew/company/${companyId}/${goalId}/delete/`);
      enqueueSnackbar('요청사항이 삭제되었습니다.', { variant: 'success' });
      mutate();
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || '요청사항 삭제에 실패했습니다.', { variant: 'error' });
      throw error;
    }
  };

  return {
    goals: data?.goals || [],
    totalGoals: data?.total || 0,
    isLoading: !error && !data,
    isValidating,
    isError: error,
    mutate,
    createGoal,
    updateGoal,
    completeGoal,
    uncompleteGoal,
    deleteGoal,
  };
}